import Api from './Api';

class TipoFaturamentoService {
  constructor() {
    this.$api = Api;
  }

  async findAll(filters) {
    return this.$api.get('/tipos-faturamento', filters);
  }

  async save(data) {
    const id = data.id || 0;

    if (id === 0) {
      return this.$api.post('/tipo-faturamento', data);
    }

    return this.$api.put(`/tipo-faturamento/${id}`, data);
  }

  async findById(id) {
    return this.$api.get(`/tipo-faturamento/${id}`);
  }

  async remove(id) {
    return this.$api.delete(`/tipo-faturamento/${id}`);
  }
}

export default new TipoFaturamentoService();
